import React from 'react';
import './Footer.css';
import {Link} from "react-router-dom"
const Footer = () => {
  return (
    <footer className="footer" id="footer-main">
      <div className="footer-content">
        <div className="footer-links">
          <div className="footer-links-column">
            <h4>Links</h4>
            <ul>
              <li><a href="#">Home</a></li>
              <li><Link to="/team">Team</Link></li>
              <li><a href="#event-heading">Events</a></li>
            </ul>
          </div>
          <div className="footer-links-column">
            <h4>Events</h4>
            <ul>
            <li><a href="/event/1" target="_blank" rel="noopener noreferrer">Technical Quiz</a></li>
            <li><a href="/event/2" target="_blank" rel="noopener noreferrer">Debugging</a></li>
            <li><a href="/event/6" target="_blank" rel="noopener noreferrer">Product Development</a></li>
            <li><a href="/event/4" target="_blank" rel="noopener noreferrer">Project Presentation</a></li>
            <li><a href="/event/5" target="_blank" rel="noopener noreferrer">Capture The Flag</a></li>
            <li><a href="/event/10" target="_blank" rel="noopener noreferrer">UI/UX Designing</a></li>
            <li><a href="/event/7" target="_blank" rel="noopener noreferrer">Bot-A-Mata</a></li>
            <li><a href="/event/8" target="_blank" rel="noopener noreferrer">Game Jam</a></li>
            <li><a href="/event/9" target="_blank" rel="noopener noreferrer">SQL Detective</a></li>
            <li><a href="/event/3" target="_blank" rel="noopener noreferrer">Code Relay</a></li>
            <li><a href="/event/11" target="_blank" rel="noopener noreferrer">Data Dash</a></li>
          </ul>
          </div>
          <div className="footer-links-column">
            <h4>Contact</h4>
            <ul>
              <li>Email: <a href="mailto:techathon@rajalakshmi.edu.in" >techathon@rajalakshmi.edu.in</a></li>
              <li>Purushoth: <a href="tel:+919384710011">9384710011</a></li>
              <li>Aden: <a href="tel:+919025685774">9025685774</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Website developed by <a href="https://github.com/Sakthilakshmi-M" target="_blank" rel="noopener noreferrer">Sakthilakshmi M</a> and <a href="https://github.com/purushothaman7" target="_blank" rel="noopener noreferrer">Purushothaman M</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
